angular.module("app").component("fashionComponent", {
  templateUrl: "app/components/dashboards/fashion/fashion.tmpl.html",
});
